import gql from "graphql-tag";

export const TESTATOR_QUERY = gql`
  query Testator($id: ID!) {
    testator(id: $id) {
      id
      userId
      fullName
      firstNames
      lastName
      email
      phone
      uniqueIdentifier
      dateOfBirth
      deceased
      deceasedDate
      age
      gender
      willCountry
      cellNumber
      cellCountryCode
      doNotContact
      maritalStatus
      maritalRegime
      isMarried
      hasChildren
      executorParty
      alternativeExecutorParty
      trustTerminationAge
      companyIsTrustee
      createChildrensTrust
      hasActivePayment
      letterOfWishes
      burialPreference
      burialPreferenceOther
      includeLivingWill
      willLocation
      hasExecutor
      isEntitledToFirstWillFree
      specificDonationsOptOut
      assetsOptOut
      numberOfChildren
      worldWideAssets
      negotiatedExecutorFeePercentage
      advisorId
      enabledFeatures
      anyAssetsLeftToSpouse
      anyAssetsLeftToNonSpouseBeneficiaries
      createdAt
      lastLogin
      acceptedTerms
      requestedACall
      dateWillSigned
      nominatedExecutorOnPaperWill
      dateStored
      bypassOmOnlyExecutor
      ratherChatEnabled
      speakToDfaAdvisorEnabled
      ratherChatRequested
      speakToDfaAdvisorRequested
      ratherChatRequestedById
      speakToDfaAdvisorRequestedById
      ratherChatRequestedAt
      speakToDfaAdvisorRequestedAt
      identityNumber {
        id
        idType
        number
        countryCode
      }
      user {
        id
        role
        advisorCode
        referrals {
          id
          testatorId
          personId
        }
      }
      advisor {
        id
        fullName
        email
        appointmentLink
        companyDefaultAdvisor
      }
      company {
        id
        tradingName
        executorship
        negotiableExecutorFee
        defaultExecutorFeePercentage
        offerTrustAdministration
        trustCompanyName
        referAFriend
        logoUrl
        companyType
      }
      people {
        id
        firstNames
        lastName
        fullName
        dateOfBirth
        email
        contactNumber
        phoneCountryCode
        contactNumber2
        phoneCountryCode2
        kinship
        gender
        displayName
        educatable
        referralInviteSent
        referralInviteSentTime
        insuranceChildValidation {
          personId
          evaluation
        }
        identityNumber {
          id
          idType
          number
          countryCode
        }
        testatorRelationships {
          id
          relation
          createdAt
        }
        distributionSpecificPercentage {
          id
        }
        distributionSpecificPercentageAlternatives {
          id
        }
        alternativeDistributionSpecificPercentage {
          id
        }
        distributionSpecificPercentageAlternativeBeneficiaries {
          id
        }
        specificDonations {
          id
        }
      }
      charities {
        id
        name
        registrationNumber
        displayName
        distributionSpecificPercentage {
          id
        }
        distributionSpecificPercentageAlternatives {
          id
        }
        alternativeDistributionSpecificPercentage {
          id
        }
        distributionSpecificPercentageAlternativeBeneficiaries {
          id
        }
        specificDonations {
          id
        }
      }
      trusts {
        id
        name
        incorporationNumber
        displayName
        testamentaryTrust
        distributionSpecificPercentage {
          id
        }
        distributionSpecificPercentageAlternatives {
          id
        }
        alternativeDistributionSpecificPercentage {
          id
        }
        distributionSpecificPercentageAlternativeBeneficiaries {
          id
        }
        specificDonations {
          id
        }
      }
      insuranceException {
        id
        exceptionReasons
      }
      remainderOfEstate {
        id
        distribution
        alternativeDistribution
        distributionSpecificPercentages {
          id
          percentage
          beneficiaryId
          beneficiaryType
          beneficiaryDisplayName
          alternativeDistribution
          alternativeBeneficiaryId
          alternativeBeneficiaryType
          alternativeBeneficiaryDisplayName
          distributionSpecificPercentageAlternativeBeneficiaries {
            id
            distributionSpecificPercentageId
            percentage
            beneficiaryId
            beneficiaryType
            beneficiaryDisplayName
          }
        }
        alternativeDistributionSpecificPercentages {
          id
          percentage
          beneficiaryId
          beneficiaryType
          beneficiaryDisplayName
        }
      }
      testatorRelationships {
        id
        relation
      }
      specificDonations {
        id
        donationType
        testatorId
        assetId
        assetType
        assetDisplayName
        monetaryAmount
        donationOrigin
        beneficiaries {
          id
          beneficiaryId
          beneficiaryType
          beneficiaryDisplayName
          beneficiaryKinship
          percentage
          alternativeDonation
          alternativeBeneficiary
        }
      }
      properties {
        id
        physicalAddress
        ownership
        percentageShare
        displayName
        marketValue
        outstandingDebt
        specificDonation {
          id
        }
      }
      vehicles {
        id
        make
        model
        color
        outstandingDebt
        displayName
        specificDonation {
          id
        }
      }
      financialAssets {
        id
        investmentType
        otherInvestmentType
        institution
        displayName
        accountNumber
        specificDonation {
          id
        }
      }
      otherAssets {
        id
        description
        displayName
        specificDonation {
          id
        }
      }
      willVersions {
        id
        status
        url
        version
        createdAt
        uploadedWills {
          id
          status
          url
          comments
          version
        }
      }
      previewWillVersions {
        id
        url
        version
        createdAt
      }
      preExistingWills {
        id
        testatorId
        url
        createdAt
      }
      insurance {
        id
        testatorId
        nominatedBeneficiaryCoverRequired
        estateAdminExpensesCoverRequired
        smoker
        educationLevel
        replacementPolicy
        monthlyIncome
        skipInsurance
        subscriptionType
        monthlyPremiumQuoted
        yearlyPremiumQuoted
        rootPolicyNumber
        rootSumAssured
        bankDetails {
          id
          accountHolderName
          bankName
          branchCode
          accountNumber
          debitOrderDay
        }
        differentTechLead {
          spId
        }
      }
      livingWill {
        id
        keptAliveByArtificialMeans
        keptAliveTimePeriod
        keptAliveTimeAmount
        resuscitate
        comfortCare
        decisionMakerNotify
      }
      estateCostCalculation {
        id
        testatorId
        totalPropertyValue
        nonPropertyAssetValue
        deemedAssetsValue
        allAssetsLeftToSpouse
        assetValueLeftToSpouse
        hasEstateDutyRollover
        estateDutyRolloverAmount
        otherLiabilities
        totalLiabilities
        executorFeePercentage
        grossEstateValue
        conveyancingFees
        executorFees
        standardAdministrativeCosts
        mastersFees
        estateDuty
        dutiableEstateBefore4aDeduction
        propertyOwnershipValue
        estimatedEstateAdministrativeCosts
        lastCalculationTime
        testamentaryTrustFees
        estateAdministrationServicesCost
        recommendedEstateCoverAmount
        coverLimitReached
        estateDutyExceeded
        capitalGainsTaxAmount
      }
      willValid
      willInvalidReason
      adTrackRecord {
        omtId
      }
    }
  }
`;

export const UPDATE_TESTATOR_MUTATION = gql`
  mutation updateTestator($id: ID!, $testatorInputDetails: TestatorInput!) {
    updateTestator(id: $id, testatorInput: $testatorInputDetails) {
      fullName
      firstNames
      lastName
      id
      email
      gender
      cellNumber
      cellCountryCode
      maritalRegime
      maritalStatus
      isMarried
      hasChildren
      trustTerminationAge
      companyIsTrustee
      executorParty
      alternativeExecutorParty
      createChildrensTrust
      worldWideAssets
      letterOfWishes
      burialPreference
      burialPreferenceOther
      includeLivingWill
      dateWillSigned
      nominatedExecutorOnPaperWill
      dateStored
      identityNumber {
        id
        idType
        number
        countryCode
      }
      willValid
      willInvalidReason
    }
  }
`;

export const UPDATE_TESTATOR_VAULT_STORAGE_SETTINGS_MUTATION = gql`
  mutation updateTestatorVaultStorageSettings(
    $id: ID!
    $vaultStorageSettingsInput: VaultStorageSettingsInput!
  ) {
    updateTestatorVaultStorageSettings(
      id: $id
      vaultStorageSettingsInput: $vaultStorageSettingsInput
    ) {
      id
      dateWillSigned
      nominatedExecutorOnPaperWill
      dateStored
      willValid
      willInvalidReason
    }
  }
`;

export const DELETE_TESTATOR_MUTATION = gql`
  mutation deleteTestator($id: ID!) {
    deleteTestator(id: $id) {
      success
    }
  }
`;

export const MARK_TESTATOR_DECEASED_MUTATION = gql`
  mutation deceaseTestator($id: ID!, $testatorInputDetails: TestatorInput!) {
    deceaseTestator(id: $id, testatorInput: $testatorInputDetails) {
      success
    }
  }
`;

export const UNMARK_TESTATOR_DECEASED_MUTATION = gql`
  mutation deceaseTestatorUndo($id: ID!) {
    deceaseTestatorUndo(id: $id) {
      success
    }
  }
`;

export const MARK_TESTATOR_DO_NOT_CONTACT_MUTATION = gql`
  mutation doNotContactTestator($id: ID!) {
    doNotContactTestator(id: $id) {
      success
    }
  }
`;

export const UNMARK_TESTATOR_DO_NOT_CONTACT_MUTATION = gql`
  mutation doNotContactTestatorUndo($id: ID!) {
    doNotContactTestatorUndo(id: $id) {
      success
    }
  }
`;

export const ALL_TESTATORS_QUERY = gql`
  query allTestators(
    $limit: Int
    $page: Int
    $search: String
    $sortBy: String
    $sortDesc: Boolean
    $categories: [String!]
    $activeTab: String
  ) {
    allTestators(
      limit: $limit
      page: $page
      search: $search
      sortBy: $sortBy
      sortDesc: $sortDesc
      categories: $categories
      activeTab: $activeTab
    ) {
      totalTestators
      testators {
        id
        firstNames
        lastName
        idNumber
        status
        email
        lastLogin
        paymentPlan
        nextBillingDate
        advisorEmail
        createdAt
        numberOfCompletedSteps
        uploadStatus
        uploadUpdatedAt
        lastWillDownloadDate
        estimatedEstateAdministrativeCosts
        doNotContact
        deceased
        deceasedDate
        category
        uniqueIdentifier
        vaultStored
        nextRequiredAction
      }
    }
  }
`;

export const TESTATOR_ACTION_COUNTS_QUERY = gql`
  query testatorActionCounts {
    testatorActionCounts {
      completeSteps
      downloadWills
      signUploadWills
      validatedWills
      inStorage
    }
  }
`;

export const SET_NEGOTIATED_EXECUTOR_FEE_MUTATION = gql`
  mutation setNegotiatedExecutorFee(
    $testatorId: ID!
    $negotiatedExecutorFeePercentage: Float
  ) {
    setNegotiatedExecutorFee(
      testatorId: $testatorId
      negotiatedExecutorFeePercentage: $negotiatedExecutorFeePercentage
    ) {
      id
      negotiatedExecutorFeePercentage
    }
  }
`;

export const REQUEST_A_CALL_MUTATION = gql`
  mutation requestACall($testatorId: ID!, $forInsurance: Boolean!) {
    requestACall(testatorId: $testatorId, forInsurance: $forInsurance)
  }
`;

export const FULL_STORY_TESTATOR_QUERY = gql`
  query Testator($id: ID!) {
    testator(id: $id) {
      id
      email
      fullName
    }
  }
`;

export const UPDATE_TESTATOR_PEOPLE = gql`
  mutation updateTestatorPeople($id: ID!, $people: TestatorPeopleInput!) {
    updateTestatorPeople(id: $id, people: $people) {
      id
      people {
        id
      }
    }
  }
`;

export const GET_ADVISOR_APPOINTMENT_LINK = gql`
  mutation getAdvisorAppointmentLink($testatorId: ID!) {
    getAdvisorAppointmentLink(testatorId: $testatorId)
  }
`;

export const INSURANCE_EXCEPTION_MUTATION = gql`
  mutation insuranceException($testatorId: ID!) {
    insuranceException(testatorId: $testatorId) {
      id
      exceptionReasons
    }
  }
`;

export const SPEAK_TO_DFA_ADVISOR_MUTATION = gql`
  mutation SpeakToDfaAdvisor($testatorId: ID!, $comment: String!) {
    speakToDfaAdvisor(testatorId: $testatorId, comment: $comment) {
      id
      ratherChatRequested
      speakToDfaAdvisorRequested
      ratherChatRequestedById
      speakToDfaAdvisorRequestedById
      ratherChatRequestedAt
      speakToDfaAdvisorRequestedAt
    }
  }
`;

export const INTERESTED_IN_FUNERAL_COVER_MUTATION = gql`
  mutation InterestedInFuneralCover($testatorId: ID!) {
    interestedInFuneralCover(testatorId: $testatorId) {
      id
      ratherChatRequested
      speakToDfaAdvisorRequested
      ratherChatRequestedById
      speakToDfaAdvisorRequestedById
      ratherChatRequestedAt
      speakToDfaAdvisorRequestedAt
    }
  }
`;
